import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import { Grid } from "@mui/material";
import { useSelector } from "react-redux";
import Loader from "components/Loader";

const LoginWithOtp = ({ onSubmit }) => {
    const { loading } = useSelector(({ loading }) => ({
        loading,
    }));
    return (
        <>
            <Loader open={loading} />
            <Grid container justifyContent={"center"} spacing={2}>
                <Grid item xs={12}>
                    <div className="container h-100">
                        <div className="row no-margin h-100">
                            <div className="bg-layer d-flex col-md-4">
                                <div className="login-box row">
                                    <h3>User login</h3>

                                    <Formik
                                        initialValues={{
                                            otp: "",
                                        }}
                                        validationSchema={Yup.object().shape({
                                            otp: Yup.string().max(255).required("OTP is required"),
                                        })}
                                        onSubmit={onSubmit}
                                    >
                                        {({ errors, handleBlur, handleChange, handleSubmit, touched, values }) => (
                                            <form onSubmit={handleSubmit}>
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text" id="basic-addon1">
                                                            <i className="fas fa-key" />
                                                        </span>
                                                    </div>
                                                    <input
                                                        autoComplete="on"
                                                        type="text"
                                                        placeholder=" Enter OTP"
                                                        name="otp"
                                                        defaultValue={values.otp}
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        className="form-control"
                                                    />
                                                    {Boolean(touched.otp && errors.otp) ? (
                                                        <div
                                                            style={{
                                                                width: "200px",
                                                                display: "block",
                                                                marginLeft: "10px",
                                                                color: "red",
                                                                fontSize: 12,
                                                            }}
                                                        >
                                                            {errors.otp}
                                                        </div>
                                                    ) : (
                                                        ""
                                                    )}
                                                </div>
                                                <p>resend OTP ?</p>
                                                <button type="submit" className="btn btn-success" onClick={handleSubmit}>
                                                    Sign In
                                                </button>
                                            </form>
                                        )}
                                    </Formik>
                                </div>
                            </div>
                        </div>
                    </div>
                </Grid>
            </Grid>
        </>
    );
};

export default LoginWithOtp;
